"use client";
import React from "react";
import "./upgrade.css";

const UpgradeToday = () => {
  return (
    <div id="upgrade-today-parent">
      <h2 className="upgrade-today-title">UPGRADE TODAY</h2>

      <div className="upgrade-today-content">
        <div className="upgrade-today-1">
          <img
            src="https://off-beat-cdn.blr1.cdn.digitaloceanspaces.com/top-assest.png"
            alt="white-shape"
          />
        </div>

        <div className="upgrade-today-2">
          <p style={{ color: "white" }}>
            Save thousands on things you do everyday! <br /> <br /> BENEFITS:
          </p>
        </div>

        <div className="upgrade-today-3">
          <div className="benefits-list">
            <ul>
              <li>- Flights & Car Hire</li>
              <li>- Tours & Activities</li>
            </ul>
            <ul>
              <li>- Dining</li>
              <li>- Deals-4-U</li>
            </ul>
            <ul>
              <li>- Holidays</li>
              <li>- Cruises</li>
            </ul>
            <ul className="mns">
              <li>- Movies</li>
              <li>- Spas</li>
            </ul>
          </div>
        </div>
      </div>

      <a
        style={{ color: "white", fontFamily: "helvetica_lt_stdblack" }}
        className="upgrade-btn"
        href="/join-now"
      >
        JOIN NOW
      </a>

      <div className="upgrade-today-banner">
        <p
          style={{
            color: "red",
            textAlign: "center",
            fontFamily: "helvetica_lt_stdroman",
            fontSize: "1.1rem",
          }}
        >
          *Off Beat Plus is an additional membership to your <br /> Off Beat
          Holiday Club membership.
        </p>
      </div>
    </div>
  );
};

export default UpgradeToday;
